import type { DialogBaseProps } from "../dialog.types.js";
import { useDialogContext } from "../use-dialog-context.js";

type Props = DialogBaseProps & {
  openState?: boolean;
};

export const DialogAction = ({ openState = true, children, className }: Props) => {
  const { setOpen } = useDialogContext();
  const handleClick = () => setOpen(openState);

  return (
    <div role="button" onClick={handleClick} className={className}>
      {children}
    </div>
  );
};
